<template>
     <div class="default-error-page" :class="{'ac-bg-gray': ac}">
        <header-component 
            :is-soon="false" 
            img-left="/trocachip/img/setinha-left-preto.svg" 
            img-right="/trocachip/img/access.png" 
            class="header-component"
        />
        
        <div class="default-error-page-content">
			<img src="../assets/images/ic_error.svg" alt="error" title="error" />
			<strong v-html="title"></strong>
        <div class="description_box">
			<div class="error_description">
                <img src="../assets/images/nowifi.svg" alt="shutdown-wifi" title="nowifi" />
                <span class="turn_off_wifi">Por favor desligue o wi-fi</span>
            </div>
            <div class="error_description">
                <img  src="../assets/images/antenna.svg" alt="shutdown-wifi" title="nowifi" />
                <span class="turn_off_wifi">A troca de chip é realizada somente pela rede móvel</span>
            </div>
        </div>
            <button class="btn btn-primary" :class="{'ac-color-black': ac, 'ac-border-yellow': ac, 'ac-bg-yellow': ac}" @click.prevent="callAction">
                {{actionLabel}}
            </button>
		</div>
     </div>
</template>

<script>
import HeaderComponent from "../components/HeaderComponent";
import {mapState} from "vuex";

export default {
    name: "DefaultError",
    components: {
        HeaderComponent,
    },
    props: {
        title: { type: String, default: "Sua troca de chip ainda não pode ser realizada" },

        actionLabel: { type: String, default: "Tente novamente" },
        action: { type: Function }
    },
    computed: {
        ...mapState({
            ac: state => state.ac,
            customer: state => state.customer,
            config: state => state.config,
            eligibilityErrorsCount: state => state.eligibilityErrorsCount
        })
    },
    methods: {
        callAction() {
            window.location.replace("https://www.trocadechip.tim.com.br");
        }
    }
}
</script>

<style lang="scss" scoped>
.default-error-page {
	width: 100vw;
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
}

.default-error-page-content {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	font-family: 'timsans_regular';
	text-align: center;
}

.default-error-page-content strong {
	font-size: 32px;
	font-weight: 300;
	margin-top: 37px;
    width: 75%;
}

.default-error-page-content span {
	margin-top: 27px;
	opacity: 0.6;
	font-size: 16px;
	color: #000000;
    width: 75%;
}
.error_description {
    padding-top: 24px;
    font-family: "timsans_regular";
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.20000000298023224px;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    vertical-align: middle;
    width: 270px;
    float: left;

}
.description_box {
    width: 75%;
    display: flex;
    flex-direction: column;
}
.turn_off_wifi {
    margin-top: 0 !important;
    padding-left: 18px;
    width: 250px;

}
button {
    margin-top: 40px;
    width: 286px;
}

</style>